<template>
  <modal
      name="schedule-calendar-modal"
      class="v--modal-box-schedule"
      :width="`100%`"
      :height="changeBrowserSize.scheduleHeight"
      :delay="100"
      :reset="true"
      :resizable="false"
      :pivotX="0.5"
      :pivotY="0.5"
      @opened="opened"
      @before-open="beforeOpen"
      @before-close="beforeClose"
  >
    <div class="FloatMenu md_overlay md_overlay_0">
      <vue-scroll>
        <div class="modal modal_0">
          <div class="md_content">
            <div class="schedule_modal_title">
              <h6 class="--blue70 mb20">
                  {{ $t('RMC.manage_schedule') }}
              </h6>
              <span class="con_add">
                <a
                    class="pointer no-drag"
                    @click="handleClick"
                >
                  <img
                      src="@/assets/images/svg/icon_addpatient_schedule.svg"
                      alt=""
                  />
                  {{ $t('RMC.add') }}
                </a>
              </span>
            </div>
            <span class="md_close">
              <img
                  src="/images/union.svg"
                  alt=""
                  @click="modalClose"
              >
            </span>
            <vue-cal
                class="vuecal--blue-theme vuecal_edit_mode"
                ref="editModeVuecal"
                :time-from="7 * 60"
                :time-to="21 * 60"
                :time-step="15"
                :twelveHour="true"
                :timeFormat="`h:mm {AM}`"
                :disable-views="['year', 'years']"
                :dblclickToNavigate = "false"
                :min-date = "minDate"
                :max-date="maxDate"
                :events="editModeEvents"
                :on-event-click="handleEventClickForEditMode"
                today-button
                active-view="week"
                small
                click-to-navigate
                :locale="lang()"
            >
              <template v-if="lang() === 'ko'" v-slot:title="{ title, view }">
                <span v-if="view.id === 'month'">{{ view.startDate.format('YYYY년 MMMM') }}</span>
                <span v-else-if="view.id === 'week'">{{ view.startDate.getWeek() + '주차' }} ({{ view.startDate.format('YYYY년 MMMM') }})</span>
              </template>
              <template #arrow-prev>
                <button
                    type="button"
                    aria-label="Previous week"
                    class="vuecal__arrow vuecal__arrow--prev"
                    @click="(event)=>{dataLoad && event.stopPropagation()}"
                    :disabled="dataLoad"
                >
                  &nbsp;<i class="angle"></i>&nbsp;
                </button>
              </template>
              <template #arrow-next>
                <button
                    type="button"
                    aria-label="Next week"
                    class="vuecal__arrow vuecal__arrow--next"
                    @click="(event)=>{dataLoad && event.stopPropagation()}"
                    :disabled="dataLoad"
                >
                  &nbsp;<i class="angle"></i>&nbsp;
                </button>
              </template>
            </vue-cal>
            <div
                v-show="editModeVuecal.id !== 'month'"
                class="schedule_modal_footer"
            >
              <div class="legend_view">
                <div class="legend no-drag">
                  <div class="color"/>
                  <div>
                    <span>
                      {{$t('RMC.patient_appointment')}}
                    </span>
                  </div>
                </div>
                <div class="legend no-drag">
                  <div class="color"/>
                  <div>
                    <span>
                      {{$t('RMC.doctor_appointment')}}
                    </span>
                  </div>
                </div>
                <div class="legend no-drag">
                  <div class="color"/>
                  <div>
                    <span>
                      {{$t('schedule')}}
                    </span>
                  </div>
                </div>
                <div
                    v-show="includeTimelineList.length !== 0"
                    class="legend no-drag"
                >
                  <div class="color add"/>
                  <div>
                    <span>
                      {{$t('status.add')}}
                    </span>
                  </div>
                </div>
                <div
                    v-show="excludeTimelineList.length !== 0"
                    class="legend no-drag"
                >
                  <div class="color minus"/>
                  <div>
                    <span>
                      {{$t('status.delete')}}
                    </span>
                  </div>
                </div>
              </div>
              <div
                  v-show="editModeVuecal.id !== 'month'"
                  class="one_month_repeat"
              >
                <div
                    class="schedule_save_btn"
                    style="width: 140px;"
                >
                  <a
                      class="btn blue btn_basics saveBtn pointer no-drag"
                      @click="handleMonthClick">
                    {{$t('RMC.one_month_repeat')}}
                  </a>
                </div>
                <div
                    class="schedule_save_btn"
                >
                  <a
                      class="btn blue btn_basics saveBtn pointer no-drag"
                      :class="includeTimelineList.length === 0 && excludeTimelineList.length === 0 ? 'disabled' : ''"
                      @click="handleSaveClick">
                    {{$t('status.save')}}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <ScheduleEditModal
        @getMySchedule="getMySchedule"
    />
    <MonthRepeat
        :weekDays="weekDays"
        @onSaveClick="handleSaveClick"
    />
    <Progress :progress="progress"/>
  </modal>
</template>

<script>
import _API from '../../../api';
import ScheduleEditModal from './scheduleEdit'
import MonthRepeat from './monthRepeat'
import Progress from './progress'
import './ko.js'
import './zh-hk.js'
import './cs.js'

export default {
  name: 'scheduleCalendar',
  components: {
    ScheduleEditModal,
    MonthRepeat,
    Progress,
  },
  props: [''],
  data() {
    return {
      editModeVuecal: '',
      editModeStartDate: '',
      editModeEndDate: '',
      scheduleList: [],
      editModeEvents: [],
      minute: 15,
      includeTimelineList: [],
      excludeTimelineList: [],
      oneMonth: false,
      path: '',
      lang: () => {
        const language = navigator?.language || navigator?.userLanguage;
        const currentLang = localStorage.getItem('lang') ?? language;
        const korean = currentLang.includes('ko');
        const chinese = currentLang.includes('zh');
        const czech = currentLang.includes('cs');

        if (korean)
          return 'ko';
        // TODO: 중국어 운영 배포시 URL 체크 삭제
        else if (!window.location.href.includes('https://manager.rebless.clinic') && chinese)
          return 'zh-hk';
        // TODO: 체코어 운영 배포시 URL 체크 삭제
        else if (!window.location.href.includes('https://manager.rebless.clinic') && czech)
          return 'cs';
        else
          return 'en';
      },
      progress: false,
      weekDays: undefined,
      dataLoad: false,
    }
  },
  methods: {
    handleClick() {
      this.$modal.show('schedule-edit-modal', 'write')
    },
    modalClose: function (event) {
      this.$modal.hide('schedule-calendar-modal');

      event?.stopPropagation();
      event?.preventDefault();
    },
    beforeOpen() {
      this.path = this.$route.path;
      this.$modal.hide('notification-modal');
    },
    beforeClose() {
      this.editModeVuecal = '';
      this.editModeStartDate = '';
      this.editModeEndDate = '';
      this.scheduleList.clear();
      this.editModeEvents.clear();
      this.includeTimelineList.clear();
      this.excludeTimelineList.clear();

      if (this.path.includes('appointments') || this.path === '/')
        this.$store.dispatch('refreshScheduleForToday', 'error');
      else if (this.path.includes('remote'))
        this.$store.dispatch('refreshScheduleForPatient', true);
      else
        this.$store.dispatch('refreshScheduleForToday', true);
    },
    opened() {
      // viewMode 캘린더의 첫 화면 날짜 view
      this.editModeVuecal = this.$refs.editModeVuecal.view;
    },
    getMySchedule(editModeStartDate = this.editModeStartDate, editModeEndDate = this.editModeEndDate) {
      const param = {
        startDatetime: this.moment.tz(editModeStartDate, this._TIME_ZONE).format(),
        endDatetime: this.moment.tz(editModeEndDate, this._TIME_ZONE).add({h: 24}).format(),
      };

      this.includeTimelineList.clear();
      this.excludeTimelineList.clear();
      this.editModeEvents = [];
      this.dataLoad = true;
      return _API.SCHEDULE.getAllScheduleByRangeForClinic(param)
          .then(({data}) => {
            if (data.isSuccess) {
              this.scheduleList = data.scheduleList;

              if (this.editModeVuecal?.id === 'month') {
                this.makeScheduleForMonthView(this.scheduleList);
              } else {
                this.makeScheduleToEditModeEvent(this.scheduleList);
                this.makeClickableEvent(editModeStartDate, editModeEndDate);
              }
            }
          })
          .catch(e => {
            console.error(`[getAllScheduleByRangeForClinic] ${e}`);
          })
          .finally(() => {
            this.dataLoad = false;
          })
    },
    makeScheduleForMonthView(scheduleList) {
      for (let value of scheduleList) {
        const item = {};
        if (value.isAppointed || !value.isAppointed && value.seqMedicalRelation !== 0) {
          // 의사가 예약한 스케쥴 or 환자가 예약한 스케쥴 만 카운트 되게 하기 위함.
          item["start"] = this.moment(value.scheduleExpectStartDatetime).format('YYYY-MM-DD HH:mm');
          const minutes = this.moment.duration(value.scheduleExpectProgressTime).asMinutes();
          item["end"] = this.moment(this.moment(value.scheduleExpectStartDatetime).format('YYYY-MM-DDTHH:mm:SSZ')).add(minutes, "m").format('YYYY-MM-DD HH:mm');

          this.editModeEvents.push(item);
        }
      }
    },
    async makeScheduleToEditModeEvent(scheduleList) {
      let patientList = this.$store.state.patientList;

      if (patientList.length === 0) {
        await _API.PATIENT_LIST.getMyPatientsAndReservedSchedulesForToday()
            .then(res => {
              if (res.data.isSuccess && res.data.failedCode === '0') {
                try {
                  this.$store.dispatch(`initPatientList`, {
                    patientList: res.data.patientList,
                  }).then(_ => {
                    patientList = res.data.patientList;
                  })
                } catch (e) {
                }
              } else {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.unexpected_error'
                });
              }
            })
            .catch(e => console.log(`[getPatientsAndSchedules]${e}`))
            .finally(() => {
            })
      }

      for (let scheduleValue of scheduleList) {
        const item = {};
        item["start"] = this.moment(scheduleValue.scheduleExpectStartDatetime).format('YYYY-MM-DD HH:mm');
        const minutes = this.moment.duration(scheduleValue.scheduleExpectProgressTime).asMinutes();
        item["end"] = this.moment(this.moment(scheduleValue.scheduleExpectStartDatetime).format('YYYY-MM-DDTHH:mm:SSZ')).add(minutes, "m").format('YYYY-MM-DD HH:mm');
        item["date"] = this.moment(this.moment(scheduleValue.scheduleExpectStartDatetime).format('YYYY-MM-DDTHH:mm:SSZ')).format('YYYY-MM-DD');
        item["startTime"] = this.moment(this.moment(scheduleValue.scheduleExpectStartDatetime).format('YYYY-MM-DDTHH:mm:SSZ')).format('HH:mm');
        item["expectProgressTime"] = scheduleValue.scheduleExpectProgressTime;
        item["seqMedicalRelation"] = scheduleValue.seqMedicalRelation;
        item["seqSchedule"] = scheduleValue.seqSchedule;
        item["scheduleStatus"] = scheduleValue.scheduleStatus;
        item["title"] = `${this.moment(item.start).format('hh:mm A')} - ${this.moment(item.end).format('hh:mm A')}`;
        item["from"] = 'server';
        item["reservableTimelineGroup"] = scheduleValue.reservableTimelineGroup;

        // 클래스 부여
        if (scheduleValue.isAppointed) {
          // 의사가 예약한 스케쥴
          item["class"] = "doctor_appointment";
          item["status"] = "doctor_appointment";
        } else if (!scheduleValue.isAppointed && scheduleValue.seqMedicalRelation === 0) {
          // 의사가 설정한 예약 가능한 스케쥴
          item["class"] = "available";
          item["status"] = "available";
        } else if (!scheduleValue.isAppointed && scheduleValue.seqMedicalRelation !== 0) {
          // 환자가 예약한 스케쥴, 취소가 불가능함.
          item["class"] = "patient_appointment";
          item["status"] = "patient_appointment";
        }

        patientList
            .filter(patientValue => scheduleValue.seqMedicalRelation === patientValue.patientInfo.seqMedicalRelation)
            .map((patientValue) => {
              if (scheduleValue.scheduleStatus === 2) {
                item["title"] = patientValue.patientInfo.patientInfoName + `(${this.$t('status.cancel')})`;
                item["class"] = "canceled_appointment";
                item["status"] = "canceled_appointment";
              } else if (scheduleValue.scheduleStatus === 1) {
                item["title"] = patientValue.patientInfo.patientInfoName + `(${this.$t('status.completed')})`;
                item["class"] = item["class"] + " completed_appointment";
                item["status"] = "completed_appointment";
              } else {
                item["title"] = patientValue.patientInfo.patientInfoName;
              }
            })

        const toDayCheck =
            item["class"] === "available" &&
            (
                (
                    this.moment(item["start"]).format('YYYY-MM-DD') === this.moment(new Date()).format('YYYY-MM-DD') &&
                    Number(this.moment(item["start"]).format('HHmm')) <= Number(this.moment(new Date()).format('HHmm'))
                )
                || Number(this.moment(item["start"]).format('YYYYMMDD')) < Number(this.moment(new Date()).format('YYYYMMDD'))
            );

        if (!toDayCheck)
          this.editModeEvents.push(item);
      }
    },
    makeClickableEvent(start, end) {
      const timeTable = this.timeTable();
      const daysArr = [];
      const days = this.moment.duration(this.moment(end).diff(this.moment(start))).get('days');

      for (let i = 0; i < days + 1; i++) {
        daysArr.push(this.moment(start).add(i, 'day'));
      }

      for (let daysValue of daysArr) {
        for (let i = 0; i < 96; i++) {
          let event = {}
          event["start"] = daysValue.format('YYYY-MM-DD') + ' ' + timeTable[i];
          event["end"] = daysValue.format('YYYY-MM-DD') + ' ' + timeTable[i + 1];
          event["title"] = `${this.moment(event.start).format('hh:mm A')} - ${this.moment(event.end).format('hh:mm A')}`;
          event["class"] = 'clickable';
          event["status"] = 'clickable';

          const toDayCheck =
              (daysValue.format('YYYY-MM-DD') === this.moment(new Date()).format('YYYY-MM-DD') && Number(this.moment(event.start).format('HHmm')) <= Number(this.moment(new Date()).format('HHmm')))
              || Number(this.moment(daysValue).format('YYYYMMDD')) < Number(this.moment(new Date()).format('YYYYMMDD'));

          if (!toDayCheck) {
            const diff = this.editModeEvents.filter((item) => {
              return item.start === event.start && item.end === event.end;
            })

            if (diff.length === 0)
              this.editModeEvents.push(event);
          }
        }
      }
    },
    timeTable() {
      const list = [];

      for (let i = 0; i < 97; i++) {
        if (i === 96)
          list.push(this.moment('2020-02-20 00:00').add(this.minute * i, "m").format('kk:mm'));

        list.push(this.moment('2020-02-20 00:00').add(this.minute * i, "m").format('HH:mm'));
      }

      return list
    },
    handleEventClickForEditMode(event, e) {
      if (event.status === 'clickable') {
        // 배열에 담기
        event.class = 'available new';
        event.status = 'available new';
        const includeData = {
          startDatetime: event.start,
          progressTime: "00:15:00"
        };
        this.includeTimelineList.pushIfNotExist(includeData);
      } else if (event.status === 'available' || event.status === 'available new') {
        event.class = 'clickable';
        event.status = 'clickable';
        if (event?.from === 'server') {
          event.class = 'clickable server';
          event.status = 'clickable server';
          const excludeData = {
            seqSchedule: event.seqSchedule,
            reservableTimelineGroup: event.reservableTimelineGroup
          }
          this.excludeTimelineList.pushIfNotExist(excludeData);
        } else {
          const includeData = {
            startDatetime: event.start,
            progressTime: "00:15:00"
          };
          this.includeTimelineList.removeItemByKeyMatch('startDatetime', includeData.startDatetime);
        }
      } else if (event.status === 'clickable server') {
        event.class = 'available';
        event.status = 'available';
        const excludeData = {
          seqSchedule: event.seqSchedule,
          reservableTimelineGroup: event.reservableTimelineGroup
        }
        this.excludeTimelineList.removeItemByKeyMatch('seqSchedule', excludeData.seqSchedule);
      } else {
        if (!(event.status === "patient_appointment" || event.status === "canceled_appointment" || event.status === "completed_appointment"))
          this.$modal.show('schedule-edit-modal', event);
      }

      e.stopPropagation();
    },
    handleSaveClick(_event, oneMonth = this.oneMonth, includeList = this.includeTimelineList, excludeList = this.excludeTimelineList, func = () => { /*This is intentional*/
    }) {
      if (includeList.length === 0 && excludeList.length === 0) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'alert.select_schedule'
        });
        return
      }

      const param = {
        includeTimelineList: includeList,
        excludeTimelineList: excludeList,
        repeatEndDatetime: oneMonth ? this.moment().add(1, 'month').format(`YYYY-MM-DDT00:00:00Z`) : ''
      }

      this.progress = true;
      _API.SCHEDULE.updateTimeline(param)
          .then(({data}) => {
            if (data.isSuccess) {
              this.$modal.show('common-alert-modal', {
                messageType: 'short',
                message: 'alert.save_completed'
              });
            } else {
              this.$modal.show('common-alert-modal', {
                messageType: 'short',
                message: 'alert.retry_again'
              });
            }

            this.includeTimelineList.clear();
            this.excludeTimelineList.clear();
            this.oneMonth = false;
            this.getMySchedule();
          })
          .finally(() => {
            this.progress = false;
            func()
          })
          .catch(e => {
            console.error(`[updateTimeline] ${e}`);
          });
    },
    handleMonthClick() {
      this.weekDays = this.$refs.editModeVuecal.weekDays;
      this.$modal.show('month-repeat-modal');
    },
  },
  watch: {
    editModeVuecal: {
      deep: true,
      handler() {
        // 내가 현재 보고 있는 달력의 시작일과 종료일(new)이 이전에 보던 것(old)과 다른 지 확인
        const oldStartDate = this.editModeStartDate;
        const oldEndDate = this.editModeEndDate;
        const newStartDate = this.moment(this.editModeVuecal.startDate).format('YYYY-MM-DD');
        const newEndDate = this.moment(this.editModeVuecal.endDate).format('YYYY-MM-DD');

        if (newStartDate !== oldStartDate || newEndDate !== oldEndDate) {
          this.editModeStartDate = this.moment(this.editModeVuecal.startDate).format('YYYY-MM-DD');
          this.editModeEndDate = this.moment(this.editModeVuecal.endDate).format('YYYY-MM-DD');
          this.scheduleList = [];
          this.editModeEvents = [];
          this.getMySchedule();
        }
      }
    },
  },
  computed: {
    minDate() {
      return new Date()
    },
    maxDate() {
      return new Date().addDays(30)
    },
    changeBrowserSize() {
      return {
        ...this.$store.getters.getBrowserSize,
        scheduleHeight: this.$store.getters.getBrowserSize.height > 767 ? 765 : this.$store.getters.getBrowserSize.height,
      }
    },
  },
}
</script>
<style lang="scss">
.v--modal-overlay[data-modal="schedule-calendar-modal"] {
  overflow: auto;

  .md_overlay {
    background: none;
    max-width: 1024px;
    margin: 0 auto;

    .modal .md_content {
      color: var(--grey70);
      background: var(--white);
      position: relative;
      border-radius: 10px;
      margin: 0 auto;
      padding: 40px 40px 20px 40px;
      width: 1024px;
      height: 100%;
      display: flex !important;
      flex-direction: column !important;

      .con_add a {
        padding: 8px 15px;
        border-radius: 5px;
        margin-left: 7px;
        border: 2px solid var(--blue70);
        color: var(--blue70);
        font-size: 15px;
        font-weight: 600;

        img {
          margin-right: 6px;
          margin-bottom: 4px;
        }
      }

      .popup_title {
        display: inline-block;
        margin-right: 15px;
      }

      .schedule_modal_title {
        display: flex;

        .edit_mode_btn {
          position: absolute;
          right: 90px;
          top: 42px;
        }

        .edit_mode_title {
          margin-left: 14px;
          color: var(--blue70);
          font-size: 15px;
          font-weight: 600;
          display: inline-block;
          margin-top: -1px;
          cursor: default;
        }
      }

      .schedule_modal_footer {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        height: 40px;

        .legend_view {
          display: flex;
          align-items: center;
          margin-right: 15px;
        }

        .legend {
          display: flex;
          align-items: center;
          margin-right: 15px;

          .color {
            height: 20px;
            width: 20px;
            border-radius: 5px;
            margin-right: 10px
          }

          span {
            color: #222222;
            font-weight: 600;
            cursor: default;
          }
        }

        .legend_view {
          .legend {
            &:nth-child(1) .color {
              background: #f86363;
            }

            &:nth-child(2) .color {
              background: #2a589f;
            }

            &:nth-child(3) .color {
              background: #EEF5FF;
              border: 1px dashed #dddddd;
            }

            .color {
              &.add {
                background: #bdffcb;
                border: 1px dashed #dddddd;
              }

              &.minus {
                background: repeating-linear-gradient(-45deg, rgba(170, 170, 170, 0.1), rgba(170, 170, 170, 0.1) 2px, #ffffff 0, #ffffff 4px);
                border: 1px dashed #dddddd;
              }
            }
          }
        }

        .one_month_repeat {
          display: flex;
          align-items: center;

          span {
            font-size: 16px;
            font-weight: 600;
            display: inline-block;
            margin-top: -6px;
            color: #999999;
            //line-height: 1.7;
          }

          div > span {
            cursor: default;
          }
        }

        .schedule_save_btn {
          width: 100px;
          margin-left: 10px;

          .disabled {
            color: var(--grey70);

            &:hover {
              background-color: var(--grey20);
              color: var(--grey70);
            }
          }
        }
      }

      .vuecal--blue-theme {
        height: var(--app-schedule-height);
        min-height: 180px;
      }

      .vuecal__title-bar {
        background-color: #fff;
        border: 1px solid #d5d5d5;
        height: 45px;

        .vuecal__title {
          span {
            //.slide-fade--right-leave {
            //  display: none;
            //}
          }

          font-size: 17px;
          font-weight: bold;
          color: #222222;

          button {
            font-size: 17px;
            font-weight: bold;
            color: #222222;
          }
        }
      }

      // 달
      .vuecal--month-view {
        .vuecal__weekdays-headings {
          padding-right: 0;
        }

        .vuecal__cell-content {
          justify-content: flex-start;
          height: 100%;
          align-items: flex-start;

          .vuecal__cell-date {
            padding: 6px;
            font-weight: bold;
            color: #222222;
            font-size: 13px;
          }
        }

        .vuecal__flex {

          .vuecal__cell {
            &:nth-child(6) {
              .vuecal__cell-content {
                > .vuecal__cell-date {
                  color: #2a589f;
                }
              }
            }

            &:nth-child(13) {
              .vuecal__cell-content {
                > .vuecal__cell-date {
                  color: #2a589f;
                }
              }
            }

            &:nth-child(20) {
              .vuecal__cell-content {
                > .vuecal__cell-date {
                  color: #2a589f;
                }
              }
            }

            &:nth-child(27) {
              .vuecal__cell-content {
                > .vuecal__cell-date {
                  color: #2a589f;
                }
              }
            }

            &:nth-child(34) {
              .vuecal__cell-content {
                > .vuecal__cell-date {
                  color: #2a589f;
                }
              }
            }

            &:nth-child(41) {
              .vuecal__cell-content {
                > .vuecal__cell-date {
                  color: #2a589f;
                }
              }
            }

            &:nth-child(7n) {
              .vuecal__cell-content {
                > .vuecal__cell-date {
                  color: #d02a2a;
                }
              }
            }
          }
        }

        .vuecal__cell--out-of-scope {
          .vuecal__cell-date {
            color: #aaaaaa !important;
          }
        }

        .vuecal__cell--today {
          .vuecal__cell-date {
            background: #2A589F;
            color: #fff !important;
            border-radius: 50px;
            width: 18px;
            height: 18px;
            line-height: 1.2;
            margin: 4px 0 0 4px;
            font-size: 10px;
            padding: 3px;
          }
        }
      }

      // 주간
      .vuecal--week-view {
        .vuecal__weekdays-headings {
          padding-right: 20px;
          padding-left: 75px;

          &.vuecal__all-day {
            display: flex;
            align-items: center;
            height: 45px;
            border-right: 1px solid #d5d5d5;
            border-left: 1px solid #d5d5d5;
            border-bottom: none;
            padding-right: 0;
          }
        }
      }

      // 공통
      .vuecal__cell--today {
        background: rgba(255, 255, 255, 0.0);
      }

      .vuecal__menu {
        background-color: #fff;
        color: #2a589f;
        border: 1px solid #d5d5d5;
        border-bottom: none;

        .vuecal__view-btn {
          height: 45px;
          font-size: 14px;
        }

        .vuecal__view-btn--active {
          border-bottom-width: 3px;
          height: 45px;
          font-weight: bold;
        }
      }

      .vuecal__weekdays-headings {
        border-left: 1px solid #d5d5d5;
        border-right: 1px solid #d5d5d5;

        .vuecal__heading {
          span {
            font-weight: bold;
            color: #222222;
          }

          &:nth-child(6) {
            span {
              color: #2a589f;
            }
          }

          &:nth-child(7) {
            span {
              color: #d02a2a;
            }
          }
        }
      }

      .vuecal__today-btn {
        position: absolute;
        left: 80px;

        span.default {
          padding: 4px 11px;
          font-weight: bold;
          border: 2px solid #2a589f;
          border-radius: 5px;
        }
      }

      .vuecal__now-line {
        z-index: 2;
        color: #06c;
      }

      .vuecal__time-column {
        width: 6em;
        border: 1px solid #d5d5d5;
        border-right: none;

        .vuecal__time-cell {
          color: #999;
          text-align: center;
          padding-right: 0;
          font-size: .9em;
          line-height: 3.5;
        }
      }

      .vuecal__cell-events-count {
        width: 15px;
        min-width: 0;
        height: 15px;
        padding: 2px;
        background: #2a589f;
        font-size: 10px;
      }

      .vuecal__cell--selected {
        background-color: rgba(255, 255, 255, 0.1) !important;
      }

      .vuecal__cell--selected:before {
        border-color: #2B88D8;
      }

      .vuecal--blue-theme:not(.vuecal--day-view) .vuecal__cell--selected {
        background-color: rgba(255, 251, 235, 0.4);
      }

      .vuecal__cell--disabled {
        background: rgba(0, 0, 0, 0.05);
      }

      .vuecal__event {
        width: calc(100% - 4px) !important;
        //height: 30px !important;
        margin: 1px 2px 0 2px !important;
        border-radius: 5px;

        left: 0 !important;

        .vuecal__event-title {
          color: #fff;
          padding: 0;
          font-weight: 700;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          height: fit-content;
          word-break: break-word;
        }

        .vuecal__event-time {
          color: #fff;
          cursor: pointer;
        }

        .vuecal__event-delete {
          display: none !important;
        }

        .vuecal__event-title--edit:focus, .vuecal__event-title--edit:hover {
          border-color: rgba(0, 0, 0, 0) !important;
          background: none !important;
          cursor: pointer !important;
        }
      }

      .vuecal__event-resize-handle {
        display: none !important;
      }

      .vuecal__event--focus, .vuecal__event:focus {
        box-shadow: unset;
        outline: none;
      }

      .canceledPatient {
        background: #b2b2b2;
      }

      .vuecal__cell--before-min {
        color: #b6d6c7;
        pointer-events: none;

        .vuecal__cell-events {
          .available {
            //display: none;
            border: none !important;
          }
        }
      }

      .vuecal__cell--after-max {
        color: #008b8b;
        pointer-events: none;
      }

      .vuecal_edit_mode {
        .vuecal__event {
          display: flex;
          justify-content: center;
          align-items: center;

          .vuecal__event-title {
            font-size: 10px;
            font-weight: unset;
          }

          &.clickable {
            background-color: transparent;

            .vuecal__event-title {
              color: #D2D0CE;
            }

            .vuecal__event-time {
              display: none;
            }

            &.server {
              //background-color: transparent;
              background: repeating-linear-gradient(-45deg, rgba(170, 170, 170, 0.1), rgba(170, 170, 170, 0.1) 2px, #ffffff 0, #ffffff 4px);
              border: 1px dashed #dddddd;

              .vuecal__event-title {
                color: var(--warning20);
                //display: none;
              }
            }
          }

          &.available {
            background-color: #EEF5FF;
            margin-top: 1px;
            cursor: pointer;
            border: 1px dashed #dddddd;

            .vuecal__event-title {
              color: #2A589F;
            }

            .vuecal__event-time {
              display: none;
            }

            &.new{
              background-color: #bdffcb;
            }
          }

          &.doctor_appointment, &.patient_appointment, &.canceled_appointment {
            margin-top: 2px;
            margin-left: 1px;
            //width: calc(100% - 1px) !important;
            z-index: 2;
            border: 1px solid #eee;

            .vuecal__event-time {
              display: none;
            }

            .vuecal__event-title {
              color: var(--grey20);
            }
          }

          &.patient_appointment {
            background-color: #f86363;
            cursor: default;

            .vuecal__event-title {
              color: var(--grey20);
            }
          }

          &.doctor_appointment {
            background-color: #2a589f;
            cursor: pointer;
          }

          &.canceled_appointment {
            background-color: #b2b2b2;
            cursor: default;
          }
        }

        .vuecal__cell--before-min {
          .vuecal__cell-events {
            display: unset;

            .vuecal__event {
              &.available {
                background-color: #f2f2f2;
              }

              .vuecal__event-title {
                color: var(--grey20);
              }
            }
          }
        }

        .month-view {
          .vuecal__cell-events-count {
            //display: none !important;
            width: 15px;
            min-width: 0;
            height: 15px;
            padding: 2px;
            background: #2a589f;
            font-size: 10px;
          }
        }
      }
    }
  }
}

@media screen and (max-height: 810px) {
  .v--modal-overlay[data-modal="schedule-calendar-modal"] .v--modal-box {
    position: unset;
    overflow: unset;
  }
  .v--modal-overlay[data-modal="schedule-edit-modal"] .v--modal-box {
    position: relative;
    overflow: hidden;
  }
  .v--modal-overlay[data-modal="month-repeat-modal"] .v--modal-box {
    position: relative;
    overflow: hidden;
  }
}

@media screen and (max-height: 1024px) {
  overflow: hidden;
}

.edit_patient_checkbox {
  padding-right: 58px;

  input[type="checkbox"]:checked + label span {
    width: 0;
    height: 0;
    background: none;
  }

  input[type="checkbox"] + label span {
    display: inline-block;
    width: 0;
    height: 0;
    margin: 0;
    vertical-align: middle;
    background: none;
  }

  input[type="checkbox"] {
    position: absolute;
    visibility: hidden;
  }

  label {
    display: block;
    position: absolute;
    width: 52px;
    height: 25px;
    border-radius: 50px;
    background-color: #ddd;
    transition-duration: 0.2s;
    margin-top: -5px;
    margin-left: 9px;
  }

  label span {
    position: absolute;
    left: 3px;
    top: 3px;
    z-index: 1;
    width: 19px !important;
    height: 19px !important;
    border-radius: 50%;
    background-color: #fff !important;
    transition-duration: 0.2s;
  }

  label:before,
  label:after {
    position: absolute;
    top: 0;
    width: 30px;
    font-size: 8px;
    line-height: 25px;
    color: #fff;
    text-align: center;
  }

  label:before {
    left: -2px;
    content: 'ON';
  }

  label:after {
    right: 0;
    content: 'OFF';
  }

  input:checked + label {
    background-color: #2a589f;
  }

  input:checked + label span {
    transform: translateX(26px);
  }
}
</style>